export default "__VITE_ASSET__AUdmmosh__"